"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportContractorQueryDto = void 0;
const class_transformer_1 = require("class-transformer");
const billing_core_ledger_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-ledger-type.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_api_report_combined_type_enum_1 = require("../enums/billing-api-report-combined-type.enum");
let BillingApiReportContractorQueryDto = class BillingApiReportContractorQueryDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: `Поиск операций связанных с конкретным(и) провайдером.
    Для поиска тестовых операций, нужно выбрать тестовых провайдеров.`,
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportContractorQueryDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Типы операций: покупки, продажи, возвраты и т.д.",
  required: false,
  enum: billing_core_ledger_type_enum_1.BillingCoreLedgerTypeEnum,
  isArray: true,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_api_report_combined_type_enum_1.BillingApiReportCombinedTypeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiReportContractorQueryDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Выплаты созданные начиная с даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiReportContractorQueryDto.prototype, "from", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Выплаты созданные до даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiReportContractorQueryDto.prototype, "to", void 0);
BillingApiReportContractorQueryDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportContractorQueryDto);
exports.BillingApiReportContractorQueryDto = BillingApiReportContractorQueryDto;
